import React from 'react'
import RemainingFuel from './RemainingFuel'
import Position from './Position'
import Odometer from './Odometer'
import ConsumedFuel from './ConsumedFuel'
import AllEventByVehicle from './AllEventByVehicle'
import Graph from './Graph'
import Grid from '@material-ui/core/Grid'
import { Query } from 'react-apollo'
import CircularProgress from '@material-ui/core/CircularProgress'
import { SORT_METRIC_BY_VEHICLE, LATEST_METRIC, METRICS_BY_DATE } from '../query/metric'
import { COUNT_EVENT_OF_CURRENT_DAY_BY_VEHICLE, REFUEL_EVENT } from '../query/event'
import {
  STATUS_BY_VEHICLE,
  ODOMETER_BY_VEHICLE
} from '../query/trackable'
import { omegaClient } from '../graphql/omegaClient'

class DashboardByVehicleContentComponent extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      latestMetrics: [],
      refuelEvents: [],
      metricsByDate: [],
      trackableStatus: null,
      loading: true
    }
    this.pollingInterval = null
  }

  latestMetrics (trackableLabels) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: LATEST_METRIC,
          variables: { trackable_labels: trackableLabels },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.latest_metrics)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  refuelEvents (trackableLabels) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: REFUEL_EVENT,
          variables: { trackable_labels: trackableLabels },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.refuel_events)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  trackableStatus (trackableId) {
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: STATUS_BY_VEHICLE,
          variables: { id: trackableId },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.trackable_status)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  formatDateToYMD (date) {
    // Format date as YYYY-MM-DD
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  metricsByDate (trackableLabel, date) {
    // Format the date to YYYY-MM-DD format
    const formattedDate = this.formatDateToYMD(date)
    return new Promise((resolve, reject) => {
      omegaClient
        .query({
          query: METRICS_BY_DATE,
          variables: { trackable_label: trackableLabel, date: formattedDate },
          fetchPolicy: 'network-only'
        })
        .then((result) => {
          resolve(result.data.metrics_by_date)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }

  fetchData () {
    this.latestMetrics([this.props.trackableLabel])
      .then((latestMetrics) => {
        this.setState({
          latestMetrics,
          loading: false
        })
      })
      .catch((error) => {
        console.log('error', error)
        this.setState({ loading: false })
      })

    this.refuelEvents([this.props.trackableLabel])
      .then((refuelEvents) => {
        this.setState({
          refuelEvents
        })
      })
      .catch((error) => {
        console.log('error', error)
      })

    this.trackableStatus(this.props.trackableLabel)
      .then((trackableStatus) => {
        this.setState({
          trackableStatus
        })
      })
      .catch((error) => {
        console.log('error fetching trackable status', error)
      })

    this.metricsByDate(this.props.trackableLabel, new Date())
      .then((metricsByDate) => {
        this.setState({
          metricsByDate
        })
      })
      .catch((error) => {
        console.log('error fetching metrics by date', error)
      })
  }

  componentDidMount () {
    // Fetch data immediately
    this.fetchData()

    // Set up polling every 1 minute (60000ms)
    this.pollingInterval = setInterval(() => {
      this.fetchData()
    }, 60000)
  }

  componentWillUnmount () {
    // Clear interval to prevent memory leaks
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval)
    }
  }
  render () {
    let endpoint = localStorage.getItem('endpoint')
    // let self = this
    // let trbImm = self.props.trbImm
    // let trackableId = self.props.trackableId
    // const currentDate = new Date()
    // currentDate.setHours(0, 0, 0, 0)
    if (this.state.loading) {
      return (
        <div style={styles.root}>
          <CircularProgress style={styles.progressStyle} color='inherit' />
        </div>
      )
    }
    return (
      <div style={styles.root}>
        <Grid container spacing={24}>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <RemainingFuel
              sort_metrics={this.state.latestMetrics}
              trbImm={this.props.trbImm}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <AllEventByVehicle
              events={this.state.refuelEvents.length}
              trbImm={this.props.trbImm}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
            <Graph
              sort_metrics={this.state.metricsByDate}
              trbImm={this.props.trbImm}
              trackableLabel={this.props.trackableLabel}
              trackableName={this.props.trackableName}
            />
          </Grid>
          {this.state.trackableStatus && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Position
                trackableStatus={this.state.trackableStatus}
                trbImm={this.props.trbImm}
                trackableLabel={this.props.trackableLabel}
              />
            </Grid>
          )}
          {this.state.trackableStatus && (
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
              <Odometer
                trackableStatus={this.state.trackableStatus}
                trackableLabel={this.props.trackableLabel}
              />
            </Grid>
          )}

          {/* { endpoint.includes('ftn.')
            ? (
              <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
                <ConsumedFuel
                  sort_metrics={this.state.latestMetrics}
                  trbImm={this.props.trbImm}
                />
              </Grid>)
            : null
          } */}
        </Grid>
      </div>
    )
  }
}

const styles = {
  root: {
    flexGrow: 1,
    marginTop: '42px',
    marginLeft: '14px',
    marginBottom: '20px'
  },
  content: {
    height: '320px'
  },
  paper: {
    textAlign: 'center',
    backgroundColor: 'grey',
    height: '380px'
  },
  progressStyle: {
    color: '#7ED321'
  }
}

export default DashboardByVehicleContentComponent
